import { findSection } from 'shared/constants/routes';

/** UI-only subtitles for nav items — does not affect routing or menu config */

const LABEL_SUBTITLES: Record<string, string> = {

  Главная: 'Обзор и мониторинг',

  Поручения: 'Рабочий центр операций',

  Клиенты: 'Управление клиентами',

  'Мои клиенты': 'Управление клиентами',

  Портфель: 'Контроль позиций',

  'Позиции / Остатки': 'Контроль позиций',

  Сделки: 'Рыночные операции',

  'Сделки QUIK': 'Рыночные операции',

  Отчеты: 'Формирование отчётов',

  Отчёты: 'Формирование отчётов',

  Администрирование: 'Системные настройки',

  Справочники: 'Справочные данные',

  Услуги: 'Пункты тарифов ЦД',

  'О системе': 'Информация о платформе',

  Контакты: 'Связь с командой CDP',

  Регистратор: 'Реестр и документы',

};

export function getMenuSubtitle(link?: string, label?: string): string | undefined {

  const subtitle = findSection(link)?.subtitle;

  if (subtitle) return subtitle;

  if (label && LABEL_SUBTITLES[label]) return LABEL_SUBTITLES[label];

  return undefined;

}

